module.exports = __webpack_public_path__ + "static/media/Camera.77fc50a8.svg";